import React from 'react'
import { TableBody, TableContainer, Table } from '@material-ui/core'
import { Paper } from '../../common/Containers'
import RolePermissionRow from './RolePermissionRow'

const RolePermissionsMatrix = ({
  items = [],
  permissions = {},
  allowedPermissionsByKey = {},
  onPermissionChange,
}) => {
  return (
    <TableContainer component={Paper} radius={9}>
      <Table style={{ minWidth: 1000 }}>
        <TableBody>
          {items.map((item) => (
            <RolePermissionRow
              key={item.key}
              itemKey={item.key}
              itemName={item.name}
              permissions={permissions[item.key] || {}}
              allowedPermissions={
                allowedPermissionsByKey[item.key] || {
                  view: true,
                  edit: true,
                  create: true,
                  delete: true,
                }
              }
              onChange={onPermissionChange}
            />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default RolePermissionsMatrix
